import { CountryCode } from "libphonenumber-js";

import { Line, LineContent, LineFlag, LineTitle } from "@/blocks/Line";
import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";

export function PlaygroundSectionNumber() {
  return (
    <Section data-test="number-section">
      <SectionHeader>
        <SectionTitle>Number</SectionTitle>
      </SectionHeader>
      <Line
        number="+33176420302"
        countryCode={"FR" as CountryCode}
        name="Paris office"
      >
        <LineFlag />
        <LineContent>
          <LineTitle />
        </LineContent>
      </Line>
    </Section>
  );
}
